import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        isLoadingNavigationMenu: false,
        navigationMenu: [],
        items:[
            {
                always_first: true,
                is_hidden: false,
                icon: '$home',
                sortable: false,
                category_name: 'home',
                text: 'navigation.home',
                route: '/',
                right: false, //пункт виден с любыми правами
            }, //home
        ],
        defaultItems: [
            {
                always_first: true,
                is_hidden: false,
                icon: '$home',
                sortable: false,
                category_name: 'home',
                text: 'navigation.home',
                route: '/',
                right: false, //пункт виден с любыми правами
            }, //home
            {
                is_hidden: false,
                icon: '$customers',
                text: 'navigation.customers',
                category_name: 'customers',
                route: '/customers/',
                right: 'customers|view',
            }, //customers
            {
                is_hidden: false,
                icon: '$garage',
                text: 'navigation.garage',
                category_name: 'garage',
                route: '/garage/',
                right: 'garage|view',
            }, //garage
            {
                is_hidden: false,
                icon: '$search',
                category_name: 'home',
                text: 'navigation.parts_and_repairtimes',
                route: '/search',
                right: 'can_use_search',
            }, //search
            {
                is_hidden: false,
                icon: '$cart',
                text: 'navigation.orders',
                category_name: 'orders',
                route: '/orders',
                right: 'all_orders|view',
            }, //orders
            {
                is_hidden: false,
                icon: '$calculator',
                category_name: 'calculations',
                text: 'navigation.calculations',
                route: '/calculations',
                right: 'calculations|view',
            }, //calculations
            {
                is_hidden: false,
                icon: '$calendar',
                category_name: 'calendar',
                text: 'navigation.calendar',
                route: '/calendar',
                right: 'calendar|view',
            }, //calendar
            {
                is_hidden: false,
                icon: '$storage',
                text: 'navigation.goods_in_storage',
                route: '/storage/',
                right: 'storages|view',
            }, //storage

            {
                is_hidden: false,
                icon: '$analytics',
                text: 'navigation.analytics',
                category_name: 'analytics',
                right: 'analytics|view',
                route: '/analytics/'
            }, //analytics
            {
                is_hidden: false,
                icon: '$mobile_phone',
                text: 'navigation.calls',
                category_name: 'calls',
                right: 'calls|view',
                route: '/calls/',
                availableOnlyInLang: "ru"
            }, //calls
            {
                is_hidden: false,
                icon: '$bids',
                text: 'navigation.bids',
                category_name: 'bids',
                right: 'bids|view',
                route: '/bids/'
            }, //bids
        ],
        footerItems: [
            {
                icon: 'mdi-lifebuoy',
                text: 'common.support',
                route: null,
                method: 'showSupportMessage'
            },
            {
                icon: '$settings',
                text: 'common.settings',
                route: '/settings/'
            },
            //{ icon: 'fa-question-circle', text: 'Help' }
        ],
    },
    getters: {
        getField, //vuex-map-fields
    },
    mutations: {
        updateField, //vuex-map-fields
        fillMenu(state, data) {
            if(!data || !data.items || data.items.length===0 || Object.keys(data).length === 0){
                state.items = [...state.defaultItems];
            } else {
                let items = [];
                let always_first = state.defaultItems.find(item=>item.always_first)
                items.push(always_first)
                let areUsedItems = [];
                data.items.forEach((item)=>{

                        let keys = Object.keys(item)
                        let key = keys[0];
                        let itemInDefault = state.defaultItems.find(el=> {
                            return el.text === key && ! el.always_first
                        })
                        if(itemInDefault) {
                            let copyItemInDefault = JSON.parse(JSON.stringify(itemInDefault));
                            areUsedItems.push(key)
                            copyItemInDefault['is_hidden'] = ! item[key]
                            items.push(copyItemInDefault)
                        }

                })
                state.defaultItems.forEach(item=>{
                    if(! areUsedItems.includes(item.text) && ! item.always_first){ // если в defaultItems есть пункты которых нет в ответе от API
                        let copyItemInDefault = JSON.parse(JSON.stringify(itemInDefault));
                        items.push(copyItemInDefault)
                    }
                })
                state.items = items
            }
        },
    },
    actions: {
        async remove({ commit, state, dispatch }) {
            return await axios
                .delete(this._vm.$apiURL + "/navigation-menu" )
                .then((response) => {
                    if (response.data.status === "success") {
                        this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                    }
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                });
        },
        async store({ commit, state, dispatch }, payload) {
            updateField(state, { path: "isLoadingNavigationMenu", value: true });
            return await axios
                .post(this._vm.$apiURL + "/navigation-menu", payload)
                .then((response) => {
                    if(response.data && response.data.status === "success" && response.data.updated) {
                        this._vm.$inform(this._vm.i18n.t("common.operation_success"));
                    }
                    return response.data.updated;
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                    return false;
                })
                .finally(() => {
                    updateField(state, { path: "isLoadingNavigationMenu", value: false });
                });
        },
        async get({ commit, state, dispatch }, payload){
            updateField(state, { path: "isLoadingNavigationMenu", value: true });
            return axios
                .get(this._vm.$apiURL + "/navigation-menu")
                .then((response) => {
                    commit('fillMenu', response.data)
                })
                .catch((error) => {
                    dispatch("common/showError", { error: error }, { root: true });
                    commit('fillMenu', [])
                })
                .finally(() => {
                    updateField(state, { path: "isLoadingNavigationMenu", value: false });
                });
        }
    },
}
